<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">申请单位</div>
          <div class="field">
            <el-input v-model.trim="query.comfullname"  clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">角色类型</div>
          <div class="field">
            <el-select v-model="query.comtypename" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'comTypeCheckIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '申请单位',calculExpr:'', addNewRowFlg: false},
          { field: 'comtypename', fieldtype: 'C', title: '角色类型',calculExpr:'', addNewRowFlg: false},
          { field: 'comtypestatusname', fieldtype: 'C', title: '申请状态',calculExpr:'',addNewRowFlg: false},
          { field: 'applyusername', fieldtype: 'C',title: '申请人',calculExpr:'',addNewRowFlg: false},
          { field: 'comtypeapplytime', fieldtype: 'T',title: '申请时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'checkusername', fieldtype: 'C',title: '审核人',calculExpr:'',addNewRowFlg: false},
          { field: 'comtypechecktime', fieldtype: 'T',title: '审核时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        comtype: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        roles: []
      }
    },
    created () {
     this.$on('ADD', () => this.addComType())
     this.$on('CHG', () => this.chgComType())
     this.$on('DEL', () => this.delComType())
      this.$on('CHECK', () => this.checkComType())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getSysCodeList()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getSysCodeList () {
        let res = await request({
          method: 'get',
          url: '/kfgl/syscode/getSysCodeList',
          params: {syscode: 'cositemcomtype'}
        })
        this.roles = res
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.comtype = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addComType () {
        let form = {
          comid: this.$store.getters.loginUser.usercomid
        }
        this.$router.push({name: 'comTypeApplyForm', params: {form: form, type: 1}})
      },
      async chgComType () {
        if (!this.comtype.comtypeid) {
          this.$message.warning('请选择一行申请记录!')
          return
        }
        this.$router.push({name: 'comTypeApplyForm', params: {form: this.comtype, type: 2}})
      },
      async checkComType () {
        if (!this.comtype.comtypeid) {
          this.$message.warning('请选择一行申请记录!')
          return
        }
        if (this.comtype.comtypestatus === '1') {
          this.$message.warning('已审核，不需要重新审核')
          return
        }
        this.comtype.userid= this.$store.getters.loginUser.userid
        let data = await request({
          url: '/ywgl/com/checkComType',
          method: "post",
          data: this.comtype
        })
        console.log(data)
        if (data.issuccess===1) {
          this.getPageList()
          this.$message.success('审核成功！')
        }
      },
      async delComType () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/com/delComType',
            method: "post",
            data: this.comtype
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async cellClick (row) {
        this.comtype = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/com/getComtypeCheckPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
